exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".mdTable01[data-v-6f92c637]{border:none}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/jikosaiten/seikaihaiten/App.vue"],"names":[],"mappings":"AACA,4BACE,WAAa,CACd","file":"App.vue","sourcesContent":["\n.mdTable01[data-v-6f92c637]{\r\n  border: none;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6f92c637","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/js/jikosaiten/seikaihaiten/App.vue
// module id = 947
// module chunks = 16